import CONSTANTS from '../Constants'
import { checkRequiredFieldsValue, customSort, filterOutboundPartnerAttributes } from './Workflow'

export const findOutboundPartnerMarkDoneStatus = (
  outboundPartnerEvents: Record<string, any> = {},
  outboundPartners: string[],
): string => {
  const status = outboundPartners.every((partner) => {
    const event = outboundPartnerEvents?.[partner]

    return event && ['INITIATED', 'SUCCESS'].includes(event.status)
    // return event && ['SUCCESS'].includes(event.status)
  })
  return status ? 'PASS' : ''
}

export const outboundPartnerAttributesAndValues = (storedAsset: any, contentResponseData: any) => {
  const metaCategoriesList = customSort(
    JSON.parse(JSON.stringify(storedAsset?.attributes || [])),
    CONSTANTS.META_CATEGORIES_SORTING.ORDER,
    CONSTANTS.META_CATEGORIES_SORTING.META_CAT,
  )

  const opAttributes: any[] = []

  let lastSortOrder = 0

  metaCategoriesList.forEach((mc: any) => {
    let metaAttributes = (mc?.metaAttributes || []).map((attr: any) => ({
      ...attr,
      sortOrder: attr.sortOrder + lastSortOrder,
    }))

    metaAttributes = filterOutboundPartnerAttributes(metaAttributes).partnerAttributes || []

    opAttributes.push(...metaAttributes)

    if (metaAttributes.length > 0) {
      lastSortOrder = Math.max(...metaAttributes.map((attr: any) => attr.sortOrder))
    }
  })

  const opValues =
    contentResponseData?.ContentMetaCategory?.reduce(
      (acc: Record<string, any>, mc: any) => ({
        ...acc,
        ...(mc?.attributes || {}),
      }),
      {},
    ) || {}

  return {
    opAttributes,
    opValues,
  }
}

const checkSendToPartnerReqData = (asset: any, metaCategory: string, attributes: any) => {
  const tollgate = asset?.tollGate?.[metaCategory]
  if (tollgate) {
    if (asset?.isStandAlonePublishing) {
      return checkRequiredFieldsValue(
        attributes.filter((attribute: any) => attribute.fieldName !== 'blitzParentContentId'),
      )
    }

    return checkRequiredFieldsValue(attributes)
  } else {
    return false
  }
}

export const generateOutboundPartnerDetails = (
  attributes: any,
  outboundMasters: any,
  storedAsset: any,
  masterKeys: any,
) => {
  const partnerNames: string[] = []
  const opAttributes = attributes.reduce((acc: any, item: any) => {
    const partners = item.attribute?.outboundPartners || []
    partners.forEach((partner: string) => {
      if (!partnerNames.includes(partner)) {
        partnerNames.push(partner)
      }
      if (!acc[partner]) {
        acc[partner] = []
      }

      acc[partner].push(item)
    })

    return acc
  }, {})
  const opMasters = (outboundMasters || []).filter((partner: any) =>
    partnerNames.includes(partner[masterKeys.key]),
  )

  const opMarkDoneDisable: Record<string, boolean> = {}

  for (const key in opAttributes) {
    opMarkDoneDisable[key] = checkSendToPartnerReqData(storedAsset, key, opAttributes[key])
  }

  return { opAttributes, opMasters, opMarkDoneDisable }
}

export const findRecentMetadataUpdatedAt = (metaCategories: any[] = []) => {
  if (!metaCategories.length) {
    return null
  }

  const latestMetaCategory = metaCategories.reduce((latest, current) => {
    const latestDate = new Date(latest?.updatedAt || 0).getTime()
    const currentDate = new Date(current?.updatedAt || 0).getTime()

    return currentDate > latestDate ? current : latest
  })

  return latestMetaCategory?.updatedAt ?? null
}

export const findOutboundPartnerValidationErrors = (
  sendDataToPartnerResponse: any,
  markDoneStatusData: any[],
) => {
  const groupedErrors = sendDataToPartnerResponse.error.errors.reduce(
    (acc: Record<string, string[]>, error: any) => {
      const match = error.match(/"([^.]*)\./)

      if (match?.[1]) {
        const metaCategory = match[1]

        if (!acc[metaCategory]) {
          acc[metaCategory] = []
        }

        acc[metaCategory].push(error)
      }

      return acc
    },
    {},
  )

  const validationErrors = markDoneStatusData.map((category: any) => ({
    markDoneStatus: category.markDoneStatus,
    metaCategory: category.metaCategoryKey,
    metaCategoryName: category.metaCategoryName,
    isValidationError: groupedErrors[category.metaCategoryKey]?.length > 0,
    errors: groupedErrors[category.metaCategoryKey] || [],
  }))

  return validationErrors
}
